/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SelectOngoingNursingInterventionsAliases {
  CHECKLIST_SELECT_ONGOING_NURSING_INTERVENTIONS = 'checklist-select-ongoing-nursing-interventions',
  FETCH_SELECT_ONGOING_NURSING_INTERVENTIONS = 'fetch-select-ongoing-nursing-interventions',
  FIELD_SELECT_ONGOING_NURSING_INTERVENTIONS = 'field-select-ongoing-nursing-interventions',
  FORM_SELECT_ONGOING_NURSING_INTERVENTIONS = 'form-select-ongoing-nursing-interventions',
  LAYOUT_SELECT_ONGOING_NURSING_INTERVENTIONS = 'layout-select-ongoing-nursing-interventions',
  MAPPER_SELECT_ONGOING_NURSING_INTERVENTIONS = 'mapper-select-ongoing-nursing-interventions',
  PANEL_SELECT_ONGOING_NURSING_INTERVENTIONS = 'panel-select-ongoing-nursing-interventions',
}
export { SelectOngoingNursingInterventionsAliases };
